var styleDataHash = "6bb50b40";
const injectCss = () => {
  var css = `.G-2lw{color:#fff}.zAnqd{font-weight:var(--wds-font-weight-regular,var(--wsr-font-weight-regular,400))}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var collapsible_list_settings_default = {
  "link": "G-2lw",
  "tooltip": "zAnqd"
};
export {
  collapsible_list_settings_default as default,
  injectCss
};
//# sourceMappingURL=collapsible-list-settings-scss.js.map
